import { addDays } from 'date-fns/addDays'
import { differenceInDays } from 'date-fns/differenceInDays'
import { format } from 'date-fns/format'
import { formatISO } from 'date-fns/formatISO'
import { parseISO } from 'date-fns/parseISO'

// DateFormat object with commonly used date formats
export const DateFormat = {
  ISO: "yyyy-MM-dd'T'HH:mm:ss'Z'", // 2023-10-15T14:30:45Z
  ISO_DATE: 'yyyy-MM-dd', // 2023-10-15
  ISO_TIME: 'HH:mm:ss', // 14:30:45
  FULL: "EEEE, MMMM do, yyyy 'at' h:mm a", // Sunday, October 15th, 2023 at 2:30 PM
  LONG: 'MMMM d, yyyy', // October 15, 2023
  MEDIUM: 'MMM d, yyyy', // Oct 15, 2023
  SHORT: 'MM/dd/yyyy', // 10/15/2023
  TIME_12: 'h:mm a', // 2:30 PM
  TIME_24: 'HH:mm', // 14:30
  TIME_24_DATE: 'EEE, MMM d HH:mm', // Sun, Oct 15 14:30
  DATE_TIME: 'yyyy-MM-dd HH:mm:ss', // 2023-10-15 14:30:45
  YEAR_MONTH: 'MMMM yyyy', // October 2023
  MONTH_DAY: 'MMMM d', // October 15
  YEAR: 'yyyy', // 2023
  DAY_OF_WEEK: 'EEEE', // Sunday
  MONTH_YEAR_SHORT: 'MM/yy', // 10/23
  MONTH_DAY_SHORT: 'MM/dd', // 10/15
  MONTH_ABBREV: 'MMM', // Oct
  MONTH_ABBREV_YEAR: 'MMM yyyy', // Oct 2023
  MONTH_ABBREV_YEAR_ABBREV: 'MMM yy', // Oct 23
  SHORT_WEEKDAY_DATE: 'EEE, MMM d', // Sun, Oct 15
  SHORT_WEEKDAY_DATE_YEAR: 'EEE, MMM d, yyyy', // Sun, Oct 15, 2023
  DATE_TIME_12: 'MM/dd/yyyy hh:mm a', // 10/15/2023 2:30 PM
  YEAR_MONTH_DAY: 'yyyyMMdd', // 20231015
}

export type DateFormatString = (typeof DateFormat)[keyof typeof DateFormat]

// Convert a Date object to ISO 8601 string
export function dateToISOString(date: Date): string {
  return formatISO(date)
}

// Parse an ISO 8601 string to a Date object
export function parseISOString(isoString: string): Date {
  return parseISO(isoString)
}

// TODO: Remove this since we already have formatDate in presentation/formatting.ts
// leaving this for now as there is a question around the formatTime fn in presentation/formatting.ts
// https://momentfi.atlassian.net/browse/ENG-4608
// Format a Date object to a custom string format

// UPD from @Vova: formatDate in presentation/fromatting is too restricting
export function formatDate(date: Date, formatString: DateFormatString): string {
  return format(date, formatString)
}

// Add a specified number of days to a date
export function addDaysToDate(date: Date, days: number): Date {
  return addDays(date, days)
}

// Calculate the difference in days between two dates
export function daysBetween(date1: Date, date2: Date): number {
  return differenceInDays(date2, date1)
}
